import React from 'react';
import { motion } from 'framer-motion';
import { Bot, Zap } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function HeroSection() {
  return <section className="relative pt-20 pb-12 px-4 overflow-hidden" data-id="element-79">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#25D366]/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-80" />
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 -z-10 pointer-events-none" data-id="element-81" />

      <div className="max-w-5xl mx-auto text-center" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-83">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366]/10 border border-[#25D366]/30 text-[#00ff41] font-semibold text-sm mb-8 shadow-[0_0_15px_rgba(37,211,102,0.2)]" data-id="element-84">
            <Bot className="w-4 h-4" data-id="element-85" />
            <span data-id="element-86">Sistema Probado en +500 Negocios Argentinos</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6 tracking-tight" data-id="element-87">
            Cómo Clonar tu Atención al Cliente con IA y Vender por WhatsApp{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#25D366] to-[#00ff41]" data-id="element-88">
              24/7
            </span>{' '}
            Sin Estar Pegado al Celular ni Pagar Agencias Caras
          </h1>

          <p className="text-xl md:text-2xl text-[#00ff41] font-medium mb-6 max-w-3xl mx-auto" data-id="element-89">
            — Incluso si no sabés nada de tecnología y hoy sentís que sos
            esclavo de los mensajes.
          </p>

          <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-90">
            Dejá de perder ventas por responder tarde. Activá tu{' '}
            <strong className="text-white" data-id="element-91">Vendedor de Hierro</strong> en una
            tarde y recuperá 4 horas de tu día mientras la IA cierra pedidos por
            vos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-4xl mx-auto mb-8" data-id="element-92">
          <div className="absolute inset-0 bg-gradient-to-b from-[#25D366]/20 to-transparent blur-3xl -z-10" data-id="element-93" />
          <img src="https://cdn.magicpatterns.com/uploads/7eWehvxXMc4dg3s316FLF5/ChatGPT_Image_9_mar_2026,_04_50_31.png" alt="Vendedor de Hierro - Sistema de IA para WhatsApp" className="w-full h-auto rounded-2xl shadow-[0_0_50px_rgba(37,211,102,0.15)] border border-white/5" data-id="element-94" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-95">
          <motion.a href="https://www.ilumente.com/cart/52267256250690:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-black font-black text-lg md:text-2xl px-8 py-5 rounded-xl transition-all shadow-[0_0_30px_rgba(37,211,102,0.4)] hover:shadow-[0_0_50px_rgba(37,211,102,0.6)] w-full sm:w-auto no-underline" data-id="element-96">
            <Zap className="w-6 h-6 fill-black" data-id="element-97" />
            SÍ, QUIERO MI CLON DE VENTAS CON IA
            <div className="absolute inset-0 rounded-xl ring-2 ring-white/20 group-hover:ring-white/40 transition-all" data-id="element-98" />
          </motion.a>
          <p className="mt-4 text-gray-400 text-sm flex items-center gap-2" data-id="element-99">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-100" />
            Acceso Inmediato • Pago Seguro • 7 Días de Garantía
          </p>
        </motion.div>
      </div>
    </section>;
}